// Resuelve el flag efectivo de Lead Retrieval combinando el flag root del usuario
// con los flags por registrationGroup. Tres estados:
//   true  → forzado ON (ignora groups)
//   false → forzado OFF (ignora groups)
//   null/undefined → OR sobre groups[].leadRetrievalEnabled
export function resolveEffectiveLeadRetrieval(rootFlag, groups) {
  if (rootFlag === true) return true;
  if (rootFlag === false) return false;
  if (!Array.isArray(groups) || groups.length === 0) return false;
  return groups.some(g => g && g.leadRetrievalEnabled === true);
}
